import { render, staticRenderFns } from "./AccountOnboardingStatus.vue?vue&type=template&id=72dabf74&scoped=true&"
import script from "./AccountOnboardingStatus.vue?vue&type=script&lang=js&"
export * from "./AccountOnboardingStatus.vue?vue&type=script&lang=js&"
import style0 from "./AccountOnboardingStatus.vue?vue&type=style&index=0&id=72dabf74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dabf74",
  null
  
)

export default component.exports